import { createRoute } from '@tanstack/react-router'
import { rootRoute, requireAuth } from './__root'
import { Settings } from '../pages/Settings'
import type { Channel, Provider, Automation, RateLimit, NodeInfo } from '../pages/Settings'
import { useState, useCallback } from 'react'

export const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings',
  beforeLoad: requireAuth,
  component: SettingsPageWrapper,
})

// Default data — in production this would come from API hooks
const defaultChannels: Channel[] = [
  { id: 'gotify', name: 'Gotify', enabled: true },
  { id: 'discord', name: 'Discord', enabled: false },
  { id: 'slack', name: 'Slack', enabled: false },
  { id: 'webhook', name: 'Webhook', enabled: true },
]

const defaultProviders: Provider[] = [
  { id: 'anthropic', name: 'Anthropic', apiKey: '', model: 'claude-sonnet-4-20250514' },
  { id: 'openai', name: 'OpenAI', apiKey: '', model: 'gpt-4o' },
]

const defaultAutomations: Automation[] = [
  { id: 'health-check', name: 'Health Check', schedule: '*/5 * * * *', enabled: true },
  { id: 'backup-scan', name: 'Backup Scan', schedule: '0 2 * * *', enabled: true },
  { id: 'cert-renew', name: 'Cert Renewal', schedule: '0 3 1 * *', enabled: false },
]

const defaultRateLimit: RateLimit = { current: 0, max: 100, windowMs: 60000 }

const defaultNodes: NodeInfo[] = []

function SettingsPageWrapper() {
  const [channels, setChannels] = useState<Channel[]>(defaultChannels)
  const [automations, setAutomations] = useState<Automation[]>(defaultAutomations)

  const handleUpdate = useCallback(
    (type: string, payload: { id: string; enabled?: boolean; apiKey?: string; model?: string }) => {
      if (type === 'channel') {
        setChannels((prev) =>
          prev.map((ch) =>
            ch.id === payload.id ? { ...ch, enabled: payload.enabled ?? ch.enabled } : ch,
          ),
        )
      }
      if (type === 'automation') {
        setAutomations((prev) =>
          prev.map((a) =>
            a.id === payload.id ? { ...a, enabled: payload.enabled ?? a.enabled } : a,
          ),
        )
      }
    },
    [],
  )

  return (
    <Settings
      channels={channels}
      providers={defaultProviders}
      automations={automations}
      rateLimit={defaultRateLimit}
      nodes={defaultNodes}
      onUpdate={handleUpdate}
    />
  )
}
